import SessionExpiringDialog from 'tio-common/components/auth/session-expiring-dialog';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type RouterService from '@ember/routing/router-service';
import type SessionService from 'tio-employee/services/session';

export default class AuthSessionExpiringDialogComponent extends Component {
  @service declare session: SessionService;
  @service declare router: RouterService;

  renew = () => {
    this.session.renew();
  };

  logout = () => {
    this.router.transitionTo('logout');
  };

  <template>
    <SessionExpiringDialog
      @isSessionExpiring={{this.session.isSessionExpiring}}
      @expireAt={{this.session.expireAt}}
      @onRenew={{this.renew}}
      @onLogout={{this.logout}}
    />
  </template>
}
